"use client";

import React, { Context, createContext, useContext, useEffect, useState } from "react";
import { filter, find } from "lodash";

import { QREditorContext } from "../QREditorContext";

import { FeedbackReview, QRFeedbackReviewCategory } from "@/types/qr";
import { QREditorContextProps } from "../QREditorContext/types";
import { QRFeedbackContextProps } from "./types";


let QRFeedbackContext: Context<QRFeedbackContextProps>;
const { Provider } = (QRFeedbackContext =
  createContext<QRFeedbackContextProps>(undefined));

const QRFeedbackProvider = ({ children }: any) => {
  const [currentView, setCurrentView] = useState(1);

  const qrEditorContext = useContext<QREditorContextProps<"feedback">>(QREditorContext);

  const [feedbackReviewData, setFeedbackReviewData] =
    useState<FeedbackReview>({
      categories: qrEditorContext?.qrData?.data?.categories as QRFeedbackReviewCategory[],
      contactData: {
        name: "",
        email: "",
        phone: "",
      },
      createdAt: "",
      id: "",
      rateAverage: 0,
      ratingBase: 0,
      updatedAt: "",
    });

  const [selectedReviewCategory, setSelectedReviewCategory] = useState<QRFeedbackReviewCategory>(feedbackReviewData.categories?.[0]);

  const [reviewContactData, setReviewContactData] = useState(undefined);

  const [ratingSelected, setRatingSelected] = useState(undefined);

  const setSelectedReviewCategoryIndex = (index: number) => {
    const category = feedbackReviewData.categories?.[index];
    setSelectedReviewCategory(category);
  }
  useEffect(() => {
    if (qrEditorContext.qrData.data) {
      const updatedCategoryNames = qrEditorContext.qrData.data?.categories?.map((category) => ({
        ...category, 
        rating: find(feedbackReviewData?.categories, { id: category.id })?.rating || null, 
        comment: find(feedbackReviewData?.categories, { id: category.id })?.comment || ""
      }));

      const updatedContactData = () => {
        const filteredContactData = filter(qrEditorContext.qrData.data?.form, (value) => value === true);
        const updatedData = Object.keys(filteredContactData).reduce((acc, key) => {
          acc[key] = feedbackReviewData.contactData[key] || "";
          return acc;
        } , {});

        return updatedData;
      } 

      setFeedbackReviewData({
        ...feedbackReviewData,
        categories: updatedCategoryNames,
        contactData: updatedContactData(),
      });
    }
  }, [qrEditorContext.qrData.data]);

  useEffect(() => {
    // Para actualizar la vista si se actualiza el nombre de la categoria o los campos de contacto
    if (!selectedReviewCategory && feedbackReviewData.categories?.length > 0) {
      setSelectedReviewCategory(feedbackReviewData.categories[0]);
    }
  }, [selectedReviewCategory, feedbackReviewData]);

  return (
    <Provider
      value={{
        feedbackReviewData,
        setFeedbackReviewData,
        selectedReviewCategory,
        setSelectedReviewCategory,
        setSelectedReviewCategoryIndex,
        reviewContactData,
        setReviewContactData,
        ratingSelected,
        setRatingSelected,
        currentView,
        setCurrentView,
      }}
    >
      {children}
    </Provider>
  );
};

export { QRFeedbackContext, QRFeedbackProvider };
